<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t('Coper-Sales-Return-Invoice-List') }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn
                :disabled="!sayfayetki.Save"
                slot="activator"
                @click="goAdd()"
                flat
              >
                <span class="hidden-sm-and-down">  {{ $t('Add-Sales-Return') }}  </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save"> {{ $t('Add-Sales-Return') }} </span>
            </v-tooltip>
          </v-toolbar>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-4>
            <v-layout wrap>
              <v-flex xs6 sm3 md2>
                <tarihim
                  :etiket="$t('Starting-Date')"
                  :detaygizle="false"
                  v-bind:defaultvalue="'ok'"
                  v-model="ListParams.Tarih1"
                >
                </tarihim>
              </v-flex>

              <v-flex xs6 sm3 md2>
                <tarihim
                  :etiket="$t('Finishing-Date')"
                  :detaygizle="false"
                  v-bind:defaultvalue="'ok'"
                  v-model="ListParams.Tarih2"
                >
                </tarihim>
              </v-flex>

              <v-flex xs8 sm3 md2>
                <cariaracomp
                  v-bind:etiket="$t('Select-Current-Account')"
                  v-model="ListParams.CariKod"
                  v-bind:Coper="true"
                ></cariaracomp>
              </v-flex>

              <v-flex xs4 sm3 md2>
                <v-btn fab small dark color="info" @click="getList()">
                  <v-icon>search</v-icon>
                </v-btn>
                <v-btn
                  fab
                  small
                  dark
                  color="info"
                  @click.native="filterDialog = true"
                >
                  <v-icon>filter_list</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-4>
            <v-data-table
              hide-actions
              class="elevation-1"
              :headers="billHeaders"
              :items="billItems"
              item-key="name"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.CariKod }}</td>
                <td class="text-xs-left">{{ props.item.FatNo }}</td>
                <td class="text-xs-left">{{ props.item.FatSeri }}</td>
                <td class="text-xs-left">{{ props.item.SatisFatNo }}</td>
                <td class="text-xs-left">{{ props.item.SatisFatSeri }}</td>
                <td class="text-xs-left">
                  {{ props.item.SatisFatTarih | dateformat }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.Tarih | dateformat }}
                </td>
                <td class="text-xs-left">
                  <v-btn flat icon color="green" @click="sendLoad(props.item)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="filterDialog" persistent max-width="490">
      <v-card>
        <v-card-title class="headline primary white--text"
          >{{ $t('Filters') }}</v-card-title
        >
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12 md5>
              <v-text-field
                :label="this.$t('Invoice-Number')"
                v-model="ListParams.FatNo"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md7>
              <v-text-field
              :label="this.$t('Invoice-Serial')"
                v-model="ListParams.FatSeri"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md5>
              <v-text-field
              :label="this.$t('Sales-Invoice-Number')"
                v-model="ListParams.SatisFatNo"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md7>
              <v-text-field
              :label="this.$t('Sales-Invoice-Serial')"
                v-model="ListParams.SatisFatSeri"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm2 md5>
              <tarihim
                :etiket="this.$t('Sales-Invoice-Date')"
                :detaygizle="false"
                v-bind:defaultvalue="'no'"
                v-model="ListParams.SatisFatTarih"
              >
              </tarihim>
            </v-flex>
            <v-flex xs12 sm2 md7>
              <pnrbul hide-details v-model="ListParams.PNR_No"> </pnrbul>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.native="cancelFilter()"
            >{{ $t('cancel_button') }}</v-btn
          >
          <v-btn color="primary" flat @click.native="getList()"
            > {{ $t('Apply-Filters') }} </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import tool from "../coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";

export default {
  data() {
    return {
      billHeaders: [
        {
          text: this.$t('Current-Code'),
          value: "carikod",
        },
        {
          text: this.$t('Invoice-Number'),
          value: "fatno",
        },
        {
          text: this.$t('Invoice-Serial'),
          value: "fatseri",
        },
        {
          text: this.$t('Sales-Invoice-Number'),
          value: "satisfatno",
        },
        {
          text: this.$t('Sales-Invoice-Serial'),
          value: "satisfatseri",
        },
        {
          text: this.$t('Sales-Invoice-Date'),
          value: "satisfattarih",
        },
        {
          text: this.$t('Invoice-Date'),
          value: "tarih",
        },
        {
          text: this.$t('Process'),
        },
      ],
      billItems: [],
      ListParams: {
        Tarih1: null,
        Tarih2: null,
        CariKod: null,
        FatSeri: null,
        FatNo: null,
        SatisFatSeri: null,
        SatisFatNo: null,
        SatisFatTarih: null,
        PNR_No: null,
      },
      filterDialog: false,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: true,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
    };
  },
  methods: {
    goAdd(){
      let url =
        "#/fatura/copersatisiadeislem/id?islem=yeni";
      window.open(url, "_target");
    },
    sendLoad(val) {
      let url =
        "#/fatura/copersatisiadeislem/id?isl=get&CariKod=" +
        val.CariKod +
        "&FatSeri=" +
        val.FatSeri +
        "&FatNo=" +
        val.FatNo +
        "&FatTarih=" +
        val.Tarih +
        "&islem=get" +
        "";
      window.open(url, "_target");
    },
    cancelFilter() {
      this.ListParams.FatSeri = null;
      this.ListParams.FatNo = null;
      this.ListParams.SatisFatSeri = null;
      this.ListParams.SatisFatNo = null;
      this.ListParams.SatisFatTarih = null;
      this.ListParams.PNR_No = null;
      this.filterDialog = false
    },
    getList() {
      let params = this.ListParams;

      tool.http_post(this, "SatisIadeFaturasiList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.billItems = response.body.data;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihim,
    cariaracomp,
    pnrbul,
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {

    // this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    // if (this.sayfayetki.Status == true) {
    //   //YETKİ OK
    // } else {
    //   this.$refs.yetkidialog
    //     .open(this.sayfayetki.Message, this.sayfayetki.islem)
    //     .then((sonuc) => {
    //       if (sonuc == true) {
    //         if (this.prevRoute != null) {
    //           var url = "#" + this.prevRoute;
    //           window.open(url, "_self");
    //         } else {
    //           var mainUrl = "#/";
    //           window.open(mainUrl, "_self");
    //         }
    //       }
    //     });
    // }
  },
};
</script>

<style>
</style>

